import ApiService from "@/common/ApiService";
import URL from "@/../public/urlConfig.json";
import vue from "vue";
const api = new ApiService(vue.prototype.$config.unauthorizedHotelFlight);
require("linqjs");

export default {

    async GetOriginList() {
        const url = "/Location/GetLocations";
        const items = (await api.Get(url)).data.data.select(t => t);
     
        return items;
    },


    async GetDestinationList() {
        const url = "/Location/GetLocations";
        const items = (await api.Get(url)).data.data.select(t => t);
        return items;
    }
}